import { render, staticRenderFns } from "./AddConfirm.vue?vue&type=template&id=6b2ff15f&scoped=true"
import script from "./AddConfirm.vue?vue&type=script&lang=js"
export * from "./AddConfirm.vue?vue&type=script&lang=js"
import style0 from "./AddConfirm.vue?vue&type=style&index=0&id=6b2ff15f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2ff15f",
  null
  
)

export default component.exports